<template>
  <el-dialog
    center
    title="开户信息"
    :visible="true"
    :before-close="() => $emit('close')"
    top="95px"
    width="1450px"
    style="padding:25px 15px 40px;"
    :close-on-press-escape="false"
  >
    <div class="main">
      <div class="title">公司信息</div>
      <div class="block">
        <div class="content__main">
          <div class="content__item">
            <div class="content__label">
              公司名称：
            </div>
            <span>{{ companyInfo.companyName }}</span>
          </div>
        </div>
        <div class="content__main">
          <div class="content__item">
            <div class="content__label">
              企业主体类型：
            </div>
            <span>{{ companyInfo.companyMainType }}</span>
          </div>
        </div>
        <div class="content__main">
          <div class="content__item">
            <div class="content__label">
              公司证件号码：
            </div>
            <span>{{ companyInfo.companyCardNo }}</span>
          </div>
        </div>
        <div class="content__main">
          <div class="content__item">
            <div class="content__label">
              营业执照副本：
            </div>
            <el-image
              style="width: 276px; height: 133px"
              :src="companyInfo.companyBusinessLicense"
              :preview-src-list="[companyInfo.companyBusinessLicense]"
            ></el-image>
          </div>
        </div>
        <div class="content__main">
          <div class="content__item">
            <div class="content__label">
              开户证件信息：
            </div>
            <span>{{ companyInfo.openAccountType }}</span>
          </div>
        </div>
        <div class="content__main">
          <div class="content__item">
            <div class="content__label">
              注册地址：
            </div>
            <span>{{ companyInfo.companyBusinessAddress }}</span>
          </div>
        </div>
        <div class="content__main">
          <div class="content__item">
            <div class="content__label">
              营业执照有效起始日：
            </div>
            <span>{{ companyInfo.companyBusinessStartDt }}</span>
          </div>
        </div>
        <div class="content__main">
          <div class="content__item">
            <div class="content__label">
              营业执照有效期终止日：
            </div>
            <span>{{ companyInfo.companyBusinessEndDt }}</span>
          </div>
        </div>
      </div>
      <div class="title">开户信息</div>
      <div class="block">
        <div class="content__main" style="width:100%">
          <div class="content__item">
            <div class="content__label" style="width:100%">
              入金账户 （此账户只用于充值使用）
            </div>
          </div>
        </div>
        <div class="content__main">
          <div class="content__item">
            <div class="content__label">
              户名：
            </div>
            <span>{{ companyInfo.companyName }}</span>
          </div>
        </div>
        <div class="content__main">
          <div class="content__item">
            <div class="content__label">
              支行名称:
            </div>
            <span>{{ kHRJMap.fySubBranchName }}</span>
          </div>
        </div>
        <div class="content__main">
          <div class="content__item">
            <div class="content__label">
              账号：
            </div>
            <span>{{ kHRJMap.fyAccountNumber }}</span>
          </div>
        </div>
        <div class="content__main">
          <div class="content__item">
            <div class="content__label">
              联行号：
            </div>
            <span>{{ kHRJMap.fyInterBankNo }}</span>
          </div>
        </div>
        <div class="content__main">
          <div class="content__item">
            <div class="content__label">
              开户行：
            </div>
            <span>{{ kHRJMap.fyOpenBankName }}</span>
          </div>
        </div>
      </div>
      <div style="margin-top:24px" class="block">
        <div class="content__main" style="width:100%">
          <div class="content__item">
            <div class="content__label" style="width:100%">
              收支账户（此账户用于项目收付款使用，不可用于充值）
            </div>
          </div>
        </div>
        <div class="content__main">
          <div class="content__item">
            <div class="content__label">
              户名：
            </div>
            <span>{{ companyInfo.companyName }}</span>
          </div>
        </div>
        <div class="content__main">
          <div class="content__item">
            <div class="content__label">
              开户行：
            </div>
            <span>{{ kHSZMap.fyFZZH }}</span>
          </div>
        </div>
        <div class="content__main">
          <div class="content__item">
            <div class="content__label">
              账号：
            </div>
            <span>{{ kHSZMap.fyFZAcc }}</span>
          </div>
        </div>
        <div class="content__main">
          <div class="content__item">
            <div class="content__label">
              支行名称:
            </div>
            <span>{{ kHSZMap.fyFZName }}</span>
          </div>
        </div>
      </div>
      <div class="title">银行电子户信息</div>
      <div class="block">
        <div class="content__main" style="width:100%">
          <div class="content__item">
            <div class="content__label">
              银行名称：
            </div>
            <span>{{ YHMap.fyBankPortBankName }}</span>
          </div>
        </div>
        <div class="content__main" style="width:100%">
          <div class="content__item">
            <div class="content__label">
              户名：
            </div>
            <span>{{ companyInfo.companyName }}</span>
          </div>
        </div>
        <div class="content__main" style="width:100%">
          <div class="content__item">
            <div class="content__label">
              银行账户编号：
            </div>
            <span>{{ YHMap.fyBankPortBankNumber }}</span>
          </div>
        </div>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="$emit('close')">关闭</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { fyInfo } from '@/api/ajax';

const COMPANY_CARD_TYPE = {
  0: '个体工商户',
  1: '营业执照注册号',
  2: '统一社会信用代码'
};
const OPEN_ACCOUNT_TYPE = {
  1: '开户许可证核准号',
  2: '基本存款账户编号'
};
const COMPANY_MAIN_TYPE = {
  1: '商业公司',
  2: '个体工商户'
};

export default {
  name: 'openBankDetails',
  props: {
    bankName: String
  },
  data() {
    return {
      companyInfo: {
        companyName: '',
        companyCardNo: '',
        openAccountType: '',
        companyBusinessAddress: '',
        companyBusinessStartDt: '',
        companyMainType: '',
        companyBusinessLicense: '',
        companyBusinessEndDt: ''
      },
      kHRJMap: {
        openName: '',
        fyAccountNumber: '',
        fyOpenBankName: '',
        fySubBranchName: '',
        fyInterBankNo: ''
      },
      kHSZMap: {
        openName: '',
        fyFZAcc: '',
        fyFZName: '',
        fyFZZH: ''
      },
      YHMap: {
        fyBankPortBankName: '',
        fyBankPortBankNumber: '',
        openName: ''
      }
    };
  },
  computed: {},
  methods: {},
  created() {
    fyInfo({
      payPassagewayCode: this.bankName
    }).then(res => {
      const { pdata } = res;
      this.kHRJMap = pdata.kHRJMap;
      this.kHSZMap = pdata.kHSZMap;
      this.YHMap = pdata.YHMap;
      this.companyInfo = pdata.tPayFyUserOpen;

      this.companyInfo.companyCardNo = `${
        COMPANY_CARD_TYPE[pdata.tPayFyUserOpen.companyCardType]
      } ${pdata.tPayFyUserOpen.companyCardNo}`;

      this.companyInfo.openAccountType = `${
        OPEN_ACCOUNT_TYPE[pdata.tPayFyUserOpen.openAccountType]
      } ${pdata.tPayFyUserOpen.openAccountCode}`;

      this.companyInfo.companyMainType =
        COMPANY_MAIN_TYPE[pdata.tPayFyUserOpen.companyMainType];
    });
  }
};
</script>

<style scoped lang="scss">
::v-deep {
  .el-dialog--center .el-dialog__body {
    text-align: initial;
    padding: 25px 40px 30px;
  }
}
.main {
  .title {
    display: flex;
    align-items: center;
    margin: 20px 0;
    font-size: 16px;
    color: #000;
    &::before {
      content: '';
      display: inline-block;
      width: 5px;
      height: 16px;
      background: #1989fa;
      margin-right: 8px;
    }
  }
  .block {
    border-radius: 10px;
    border: 1px solid #cfcfcf;
    font-size: 14px;
    padding: 30px 15px;
    display: flex;
    flex-wrap: wrap;
    .content__main {
      width: 50%;
      padding: 0px 25px;
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
    }
    .content__item {
      margin: 15px 0;
      display: flex;
      justify-content: flex-start;
    }
    .content__label {
      width: 180px;
      color: #000;
    }
  }
}
</style>
